import React from 'react';

function AboutSection() {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="h-100">
              <h1 className="display-6 mb-5">20 Años de Experiencia en Climatizacion</h1>
              <div className="row g-4 mb-4">
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <img className="flex-shrink-0 me-3" src="/img/icon/icon-07-primary.png" alt="" />
                    <h5 className="mb-0">Tecnicos Ecpertos</h5>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <img className="flex-shrink-0 me-3" src="/img/icon/icon-09-primary.png" alt="" />
                    <h5 className="mb-0">Calidad de Servicios</h5>
                  </div>
                </div>
              </div>
              <p className="mb-4">Diseñamos, instalamos y mantenemos sistemas de flujo de aire según normativa <br />Damos Soluciones integrales para el confort y la eficiencia de tus instalaciones. Calidad, compromiso y tecnología al servicio de tu empresa.</p>
              <div className="border-top mt-4 pt-4">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle me-3">
                        <i className="fa fa-phone-alt text-white"></i>
                      </div>
                      <h5 className="mb-0">+56 9 45474366</h5>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="d-flex align-items-center">
                      <div className="btn-lg-square bg-primary rounded-circle me-3">
                        <i className="fa fa-envelope text-white"></i>
                      </div>
                      <h5 className="mb-0">contacto@tamaservice.cl</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row g-3">
              <div className="col-6 text-end">
                <img className="img-fluid w-75 wow zoomIn" data-wow-delay="0.1s" src="/img/imagen1.jpeg" style={{marginTop: '25%'}} alt="" />
              </div>
              <div className="col-6 text-start">
                <img className="img-fluid w-100 wow zoomIn" data-wow-delay="0.3s" src="/img/image2.jpeg" alt="" />
              </div>
              <div className="col-6 text-end">
                <img className="img-fluid w-50 wow zoomIn" data-wow-delay="0.5s" src="/img/about-3.jpg" alt="" />
              </div>
              <div className="col-6 text-start">
                <img className="img-fluid w-75 wow zoomIn" data-wow-delay="0.7s" src="/img/imagen3.jpeg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutSection;